const Failure = (props) => {

    return (
        <div className="success-container">
            <img src={require("../images/failure.jpg")} alt="Cancel" />       
            <h1>Your order wasn't successfully!</h1>
        </div>
    )
}

export default Failure;